export const Zona = {
    Circondario: 0,
    Distretto: 1,
}

export const ZonaOptions =
    Object.keys(Zona).map(e => {
        return {
            label: e,
            zona: Zona[e],
        }
    })

export const TipoContatto = {
    Email: "Email",
    Telefono: "Telefono",
    Fax: "Fax",
    Pec: "Pec",
    SitoWeb: "SitoWeb",
    AssistenzaPct: "AssistenzaPct",
    Referente: "Referente",
    Urp: "Urp",
    Casellario: "Casellario",
    Link: "Link",
}

export const TipoContattoOptions =
    Object.keys(TipoContatto).map(e => {
        return {
            label: e,
            tipo: TipoContatto[e],
        }
    })

export const SearchType = {
    Comune: 0,
    Distretto: 1,
    Regione: 2,
    TipoUfficio: 3,
    Libera: 4,
}

export const SearchTypeOptions = [
    { label: "Comune", tipo: SearchType.Comune },
    { label: "Distretto e suoi circondari", tipo: SearchType.Distretto },
    { label: "Regione e sue province", tipo: SearchType.Regione },
    { label: "Tipo ufficio", tipo: SearchType.TipoUfficio },
    { label: "Libera", tipo: SearchType.Libera },
]